import { AxiosResponse } from 'axios';
import ApiPath from '../constants/api';
import apiCall from '../utils/api';

export type IhutSurveyType = 'FEEDBACK' | 'SCREENER';

export type IhutSurvey = {
  id: string;
  type: IhutSurveyType;
  surveyStatus: string;
  status: string;
  startTime: string;
  endTime: string;
  completePoints: number;
};

export type IhutShippingDetails = {
  id: string;
  outBoundShippingId: string;
  provider: string;
  trackingNumber: string;
  status: string;
  shippedOn: string;
  deliveredOn: string;
  address: string;
  received: boolean;
  mustBeShippedBy: string;
};

export type IhutActivityApi = {
  projectId: number;
  ihutProjectId: string;
  shortId?: string;
  name: string;
  surveyName?: string;
  surveyLink?: string;
  status: string;
  createTime: string;
  testingDuration: string;
  supportRequested: boolean;
  testingCompleted: boolean;
  customerInstructions: string;
  surveys: IhutSurvey[];
  shippingDetails: IhutShippingDetails;
};

export type IhutAvailableActivitiesApi = {
  shortId?: string;
  projectId: string;
  projectName: string;
  testingCompleted: boolean;
  shipmentReceived: boolean;
  testingDuration: string;
  createdAt: string;
};

export type IhutAvailableActivities = Omit<
  IhutAvailableActivitiesApi,
  'projectName'
> & {
  name: string;
  stepStatus: number;
  completeBy: string;
};

export const getIhutAvailableActivitiesApi = () => {
  return apiCall(ApiPath.ihutAvailableActivities) as Promise<
    AxiosResponse<IhutAvailableActivitiesApi[]>
  >;
};

export type DeliveryCardStatus = 'on-the-way' | 'delivered';
export type SupportCardStatus = DeliveryCardStatus | 'in-support' | 'confirmed';

export type IhutActivity = IhutActivityApi & {
  stepStatus: number;
  deliveryCardStatus: DeliveryCardStatus;
  supportCardStatus: SupportCardStatus;
  deliveryConfirmedOn?: string;
  survey?: IhutSurvey;
  isFeedbackSurveyTaken: boolean;
};

export const getIhutProjectDetailsApi = (projectId: string) => {
  return apiCall(ApiPath.ihutProjectDetails(projectId)) as Promise<
    AxiosResponse<IhutActivityApi>
  >;
};

export type SupportRequestPayload = {
  panelistId: string;
  shortId: string;
};

type SupportRequestContent = {
  supportId: number;
  issueCategory: string;
  activityType: string;
  shortId: string;
  status: string;
  description: string;
  createTime: string;
  updateTime: string;
};

export type SupportRequestResponse = {
  totalElements: number;
  content: SupportRequestContent[];
};

export const getSupportRequest = (payload: SupportRequestPayload) => {
  return apiCall(ApiPath.supportRequest, 'GET', payload) as Promise<
    AxiosResponse<SupportRequestResponse>
  >;
};

export type PanelistStateIhutPayload = {
  surveyId: string;
  outBoundShippingId: string;
  shortId?: string;
};

export type PanelistStatusPayload = {
  delivery?: boolean;
  disqualifyPanelist?: boolean;
  testing?: boolean;
};

export type UpdatePanelistStatePayload = {
  params: PanelistStateIhutPayload;
  status: PanelistStatusPayload;
};

export const updatePanelistStates = (payload: UpdatePanelistStatePayload) => {
  return apiCall(ApiPath.updatePanelistStates, 'POST', payload) as Promise<
    AxiosResponse<unknown>
  >;
};
